import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Spin, Input } from 'antd';
import PortalLayout from '../../components/portal';
import SingleCompetition from '../../components/single_competition';
import { get } from '../../commons/http';
import styles from './style.less';

const STATUS_TABS = [
  { key: 'all', text: '全部' },
  { key: 'active', text: '进行中' },
  { key: 'before', text: '未开始' },
  { key: 'after', text: '已结束' },
];

/**
 * 官网公开赛事中心：无需登录即可浏览所有赛事基本信息
 */
export default class PortalCompetition extends Component {
  state = {
    competitions: [],
    loading: true,
    tab: 'all',
    keyword: '',
  };

  componentDidMount() {
    this.fetchCompetitions();
  }

  fetchCompetitions = async () => {
    try {
      const response = await get('/competition/all');
      if (response.code === 0) {
        this.setState({
          competitions: response.data.competitions || [],
          loading: false,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  getFiltered = () => {
    const { competitions, tab, keyword } = this.state;
    let list = competitions;
    if (tab !== 'all') {
      const status = tab === 'before' ? 0 : tab === 'active' ? 1 : 2;
      list = list.filter((c) => c.status === status);
    }
    if (keyword) {
      list = list.filter(
        (c) =>
          (c.title || '').includes(keyword) || (c.desc || '').includes(keyword)
      );
    }
    return list;
  };

  render() {
    const { loading, tab } = this.state;
    const list = this.getFiltered();

    return (
      <PortalLayout>
        <div className={styles.container}>
          <div className={styles.head}>
            <h1 className={styles.title}>赛事中心</h1>
            <p className={styles.subtitle}>
              了解赛事信息，注册登录后即可组队报名参赛；
              <Link to="/portal/team-board" className={styles['team-link']}>
                找不到队友？去组队求助看看 →
              </Link>
            </p>
          </div>

          <div className={styles.toolbar}>
            <div className={styles.tabs}>
              {STATUS_TABS.map((t) => (
                <button
                  key={t.key}
                  className={`${styles.tab} ${
                    tab === t.key ? styles.active : ''
                  }`}
                  onClick={() => this.setState({ tab: t.key })}
                >
                  {t.text}
                </button>
              ))}
            </div>
            <Input.Search
              placeholder="搜索赛事名称 / 简介"
              allowClear
              className={styles.search}
              onSearch={(v) => this.setState({ keyword: v.trim() })}
              onChange={(e) => {
                if (!e.target.value) this.setState({ keyword: '' });
              }}
            />
          </div>

          {loading ? (
            <div className={styles.loading}>
              <Spin size="large" />
            </div>
          ) : list.length > 0 ? (
            <div className={styles.grid}>
              {list.map((c) => (
                <SingleCompetition key={c._id} competition={c} publicMode />
              ))}
            </div>
          ) : (
            <div className={styles.empty}>暂无相关赛事</div>
          )}
        </div>
      </PortalLayout>
    );
  }
}
